module.exports = __webpack_public_path__ + "static/media/themesberg.105e5059.svg";